
class SendMessageModal extends ModalView {

    get defaults() {
        return {
            'title': 'Send a Message',
            'cancel': 'Cancel',
            'subject': 'Message about {subject}',
            'message': '',
            'guests': []
        };
    };

    initialize () {
        super.initialize.apply(this, arguments);
        this.options.url = urls.get('send_message_modal', {
            event_id: window.event_id
        });
        this.options = _.extend({}, this.defaults, this.options);
        this.options.url_parameters = {
            title: this.options.title,
            cancel: this.options.cancel,
            subject: this.options.subject,
            message: this.options.message,
            template: this.options.template
        };
    };

};


window.SendMessageModal = SendMessageModal;



// WEBPACK FOOTER //
// ./assets/es6/event/view/send_message_modal.es6